import Vue from 'vue'
import Router from 'vue-router'
import Homepage from "@/views/Homepage";
import AdminHomepage from "./src/views/AdminHomepage";
import NewPrototype from "@/views/NewPrototype";
import EditPrototype from "./src/views/EditPrototype";
import Login from "./src/views/Login";

Vue.use(Router);
export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes:
        [
            {
                path: '/',
                name: 'homepage',
                components: {
                    default: Login,
                    user: Homepage,
                    admin: AdminHomepage
                }
            },
            {
                path: '/new',
                name: 'new',
                components: {
                    default: Login,
                    user: Homepage,
                    admin: NewPrototype
                }
            },
            {
                path: '/edit/:path',
                name: 'edit',
                components: {
                    default: Login,
                    user: Homepage,
                    admin: EditPrototype
                }
            },
            {
                path: '/config',
                name: 'config',
                components: {
                    default: Login,
                    user: Homepage,
                    admin: () => import('./src/views/AdminConfig.vue')
                }
            },
            {
                path: '/admin',
                name: 'admin',
                components: {
                    default: Login,
                    user: Homepage,
                    admin: () => import('./src/views/AdminSettings.vue')
                }
            },
            // {
            //     path: '*',
            //     name: 'unused',
            //     components: {
            //         default: Login,
            //         user: Homepage,
            //         admin: AdminHomepage
            //     }
            // }
        ]
});
